import { useSaveStatusStore } from '../shared/store/useSaveStatusStore'
import { toastSink } from '../shared/ui/Toast/toastSink'

// frontend-restructuring §1a — global save-pulse, lifted out of a `Home.jsx` effect that
// reassigned `window.fetch` from inside a component (README §2.2.1 rule 7).
//
// Any POST/PUT/DELETE that resolves flips the status dot in `Menu2` (via `useSaveStatusStore`)
// and, on failure, raises a toast. Wraps `window.fetch` exactly once, at module load — same
// pattern as the 401 wrapper at the top of `UserContext.jsx`. It only awaits whatever wrapper
// ran before it, so install order between the two doesn't matter.

const MUTATING = new Set(['POST', 'PUT', 'DELETE'])
let installed = false

export function installSavePulse() {
  if (installed || typeof window === 'undefined') return
  installed = true

  const upstream = window.fetch
  window.fetch = async (...args) => {
    const method = (args[1]?.method || 'GET').toUpperCase()
    if (!MUTATING.has(method)) return upstream(...args)

    try {
      const res = await upstream(...args)
      if (res.ok) {
        useSaveStatusStore.getState().pulse(true)
      } else {
        useSaveStatusStore.getState().pulse(false)
        toastSink.error(`HTTP Error ${res.status}`)
      }
      return res
    } catch (err) {
      useSaveStatusStore.getState().pulse(false)
      toastSink.error('Network Error')
      throw err
    }
  }
}
